export default __webpack_public_path__ + "static/media/user.ed2e0648.svg";